import { render, staticRenderFns } from "./CollapsePanel.vue?vue&type=template&id=cd6fa4be&scoped=true"
import script from "./CollapsePanel.vue?vue&type=script&lang=js"
export * from "./CollapsePanel.vue?vue&type=script&lang=js"
import style0 from "./CollapsePanel.vue?vue&type=style&index=0&id=cd6fa4be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6fa4be",
  null
  
)

export default component.exports